<template>
  <br/>
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="search" class="form-label me-2 mt-2">Search</label>
      <input id="search" class="form-control" placeholder="Name, slug" v-model="keyword" @input="searchKeyword"/>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="per-page" class="form-label me-2 mt-2">Per page</label>
      <select id="per-page" class="form-control" v-model="perPage" @change="perPageFilter(perPage)">
        <option :value="10">10</option>
        <option :value="20">20</option>
        <option :value="50">50</option>
      </select>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="country" class="form-label me-2 mt-2">Country</label>
      <select id="country" class="form-control" v-model="selectedCountry" @change="changeCountry(selectedCountry)">
        <option value="">All</option>
        <option v-for="country in countries" :key="country.value" :value="country.value">{{ country.name.charAt(0) + country.name.slice(1).toLowerCase() }}</option>
      </select>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="category" class="form-label me-2 mt-2">Content category</label>
      <select class="form-control" id="category" v-model="category" @change="changeCategory(category)">
        <option value="">
          All
        </option>
        <option
            v-for="[key, value] in Object.entries(contentCategories)"
            :key="key"
            :value="key"
        >
          {{ value }}
        </option>
      </select>
    </div>
  </div>
  <div class="d-flex justify-content-end mb-3">
    <div >
      <router-link
          :to="{ name: 'CreatePartner' }"
          class="btn btn-success form-control"
          aria-label="Add new partner"
      >
        <span>Add partners</span>
      </router-link>
    </div>
  </div>
  <div class="table-responsive">
    <div class="alert alert-success" role="alert" v-if="success">
      {{ success}}
    </div>
    <div class="alert alert-danger" role="alert" v-if="errorConfirm">
      {{ errorConfirm}}
    </div>
    <table class="table">
      <thead>
      <tr>
        <th scope="col"># ID</th>
        <th scope="col">Creator name, slug</th>
        <th scope="col">Site</th>
        <th scope="col">Country</th>
        <th scope="col" style="width: 162px;">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="channels.length > 0" v-for="channel in channels">
        <th scope="row">{{channel.id}}</th>
        <td>
          <img :src="channel.logo" alt="No photo" class="profile-photo"/>
          <p>{{channel.name}}</p>
          <a :href="channel.link">{{channel.slug}}</a>
        </td>
        <td>{{channel.url}}</td>
        <td>{{ getCountryName(channel.country_code) }}</td>
        <td>
          <div class="btn-group-sm d-flex gap-3" role="group">
            <router-link :to="{name: 'UpdatePartner', params: {id: channel.id}}" class="btn btn-warning">Edit</router-link>
            <button @click="deletePartner(channel.id, channel.name)" class="btn btn-danger">Delete</button>

          </div>
        </td>
      </tr>
      <tr v-else-if="loading">
        <td colspan="7" class="text-center"><font-awesome-icon icon="fa-solid fa-sync" spin/></td>
      </tr>
      <tr v-else>
        <td colspan="7" class="text-center">No partners</td>
      </tr>
      </tbody>
    </table>
    <div class="d-flex justify-content-between" v-if="totalRecords >= 1">
      <div>
        <div class="p-2">
          <p>Total partners: {{ totalRecords }}</p>
        </div>
      </div>
      <div>
        <div class="p-2">
          <nav v-if="totalPages >= 1" aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item" :class="{disabled: currentPage - 1 < 1}">
                <a @click="paginate(currentPage - 1)" class="page-link">Previous</a>
              </li>
              <li class="page-item" :class="{active: 1 === currentPage}">
                <a @click="paginate(1)" class="page-link" :class="{'not-clickable': currentPage === 1}">1</a>
              </li>
              <li class="page-item" v-if="currentPage - 2 > 1">
                <a href="#" class="page-link">...</a>
              </li>
              <li class="page-item" v-if="currentPage - 2 > 1">
                <a @click="paginate(currentPage - 2)" class="page-link">{{ currentPage - 2}}</a>
              </li>
              <li class="page-item" v-if="currentPage - 1 > 1">
                <a @click="paginate(currentPage - 1)" class="page-link">{{ currentPage - 1}}</a>
              </li>
              <li class="page-item" v-if="currentPage !== 1"  :class="{active: currentPage}">
                <a @click="paginate(currentPage)" class="page-link" :class="{'not-clickable': currentPage}">{{currentPage }}</a>
              </li>
              <li class="page-item" v-if="currentPage + 1 <= totalPages">
                <a @click="paginate(currentPage + 1)" class="page-link">{{ currentPage + 1}}</a>
              </li>
              <li class="page-item" v-if="currentPage + 2 <= totalPages">
                <a @click="paginate(currentPage + 2)" class="page-link">{{ currentPage + 2}}</a>
              </li>
              <li class="page-item" v-if="currentPage + 2 < totalPages">
                <a href="#" class="page-link">...</a>
              </li>
              <li class="page-item" v-if="currentPage !== totalPages && currentPage + 2 < totalPages" :class="{active: totalPages === currentPage}">
                <a @click="paginate(totalPages)" class="page-link" :class="{'not-clickable': totalPages === currentPage}">{{totalPages }}</a>
              </li>
              <li class="page-item" :class="{disabled: currentPage + 1 > totalPages}">
                <a @click="paginate(currentPage + 1)" class="page-link">Next</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios';
import _debounce from "lodash/debounce";
import Swal from "sweetalert2";
import axiosInstance from "lodash";

export default {
  data() {
    return {
      loading: true,
      disableExport: false,
      channels: [],
      country_code: '',
      countries: [],
      errorConfirm: '',
      selectedCountry: '',
      status: '',
      category: '',
      adult: '',
      contentCategories: {},
      success: '',
      keyword: '',
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      perPage: 20,
      disableConfirm: false,
      disableDeny: false
    }
  },

  mounted() {
    let status = this.$route.query.status ?? '';
    this.status = this.$route.query.status ?? '';
    this.success = this.$route.query.channel_deleted ? 'Creator and their subscriptions were deleted successfully' : '';
    this.fetchContentCategories();
    this.getChannels(1, 20, '', status, '', '', '');
    this.getCountries();
  },

  methods: {
    getCountries() {
      this.loading = true;
      axios.get(`/admin/countries`).then(response => {
        this.countries = Array.isArray(response.data) ? response.data : [];
        this.loading = false;
      })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
    },


    debounceGetChannels: _debounce(function (page, perPage, country, status, category, keyword, adult) {
      this.loading = true;
        const params = {};
        if (page !== undefined && page !== null) params.page = page;
        if (perPage !== undefined && perPage !== null) params.per_page = perPage;
        if (country !== undefined && country !== null && country !== '') params.country = country;
        if (status !== undefined && status !== null && status !== '') params.status = status;
        if (category !== undefined && category !== null && category !== '') params.category_id = category;
        if (adult !== undefined && adult !== null && adult !== '') params.adult = adult;
        if (keyword !== undefined && keyword !== null && keyword !== '') params.keyword = keyword;
      axios.get(`/admin/partners` ,{params})
          .then(response => {
            this.channels = response.data.data;
            this.totalPages = response.data.last_page;
            this.totalRecords = response.data.total;
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
          });
    }, 500),

    async deletePartner(id, name) {
      const confirmed = await Swal.fire({
        title: 'Confirmation of deletion',
        text: `You are sure you want to delete a partner "${name}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6'
      });

      if (confirmed.isConfirmed) {
        this.loading = true;

        try {
          const response = await axios.delete(`/admin/partners/${id}`);

          this.success = `partner "${name}" successfully deleted`;

          this.getChannels(
              this.currentPage,
              this.perPage,
              this.selectedCountry,
              this.status,
              this.category,
              this.adult,
              this.keyword
          );

          setTimeout(() => this.success = '', 3000);
        } catch (error) {
          console.error('Error deleting a partner:', error);
          this.errorConfirm = error.response?.data?.message || 'Error deleting a partner';
          setTimeout(() => this.errorConfirm = '', 3000);
        } finally {
          this.loading = false;
        }
      }
    },


    getChannels(page, perPage, country, status, category, keyword, adult) {
      this.debounceGetChannels(page, perPage, country, status, category, adult, keyword);
    },
    changeCountry(country) {
      this.selectedCountry = country;
      this.getChannels(this.currentPage, this.perPage, this.selectedCountry, this.status, this.category, this.adult, this.keyword);
    },
    changeStatus(status) {
      this.status = status;
      this.getChannels(this.currentPage, this.perPage, this.selectedCountry, this.status, this.category, this.adult, this.keyword);
    },
    changeCategory(category) {
      this.category = category;
      this.getChannels(this.currentPage, this.perPage, this.selectedCountry, this.status, this.category, this.adult, this.keyword);
    },
    changeAdult(adult) {
      this.adult = adult;
      this.getChannels(this.currentPage, this.perPage, this.selectedCountry, this.status, this.category, this.adult, this.keyword);
    },
    searchKeyword() {
      this.getChannels(this.currentPage, this.perPage, this.selectedCountry, this.status, this.category, this.adult, this.keyword);
    },
    perPageFilter(perPage) {
      this.perPage = perPage;
      this.getChannels(this.currentPage, this.perPage, this.selectedCountry, this.status, this.category, this.adult, this.keyword);
    },
    paginate(page) {
      this.currentPage = page;
      this.getChannels(this.currentPage, this.perPage, this.selectedCountry, this.status, this.category, this.adult, this.keyword);
    },
    fetchContentCategories() {
      axios.get(`/admin/partner-categories/list`)
          .then(response => {
            this.contentCategories = response.data;
          })
          .catch(error => {
            console.log(error);
          });
    },

    getCountryName(countryId) {
      if (this.countries && Array.isArray(this.countries)) {
        const country = this.countries.find(c => c.value === countryId);
        return country ? country.Label : '';
      }
      return '';
    },

    async confirmChannel(channel, name) {
      const confirmed = await Swal.fire({
        title: 'Confirmation',
        text: `Are you sure you want to confirm this creator ${name}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, proceed',
        cancelButtonText: 'Cancel'
      });
      if (confirmed.isConfirmed) {
        this.success = '';
        this.error = '';
        this.reason = '';
        this.disableConfirm = true;
        await axios.put(`admin/channel/confirm/${channel}`)
            .then(response => {
              this.success = response.data.message;
              this.disableConfirm = false;
              this.getChannels(1, 20, '', 'pending_check','');
              setTimeout(() => this.success = '', 60000);
            })
            .catch(error => {
              if (error.response.status === 422) {
                this.errorConfirm = error.response.data.message;
                this.disableConfirm = false;
                setTimeout(() => this.error = '', 60000);
              }
            })
      }
    },
    async denyChannel(channel, name) {
      const confirmed = await Swal.fire({
        title: 'Confirmation',
        text: `Are you sure you want to perform this operation ${name}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, proceed',
        cancelButtonText: 'Cancel'
      });
      if (confirmed.isConfirmed) {
        this.success = '';
        this.disableDeny = true;
        axios.put(`admin/channel/deny/${channel}`)
            .then(response => {
              this.success = response.data.message;
              this.disableDeny = false;
              this.getChannels(1, 20, '', 'pending_check','');
              setTimeout(() => this.success = '', 60000);
            })
            .catch(error => {
              this.disableDeny = false;
            })
      }
    },
    confirmExport() {
      Swal.fire({
        title: "Do you want to export filtered creators ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Export",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          this.exportChannels();
        } else if (result.isDenied) {

        }
      });
    },
    exportChannels() {
      this.disableExport = true;
      axios.post(`/admin/export/channel-information`, {
        'keyword': this.keyword,
        'country': this.selectedCountry,
        'status': this.status,
        'category': this.category,
        'adult' : this.adult
      }, {
        responseType: 'blob'
      })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'channels-' + Math.floor(Date.now() / 1000) + '.xlsx');
            document.body.appendChild(link);
            link.click();
            this.disableExport = false;
          })
          .catch(error => {
            this.disableExport = false;
            console.log(error);
          });
    }
  }
}
</script>
